import React from "react";
import { Outlet } from "react-router-dom";
import FlowingCircles from "../../pages/index/components/FlowingCircles.tsx";

const AuthLayout: React.FC = () => {
  return (
    <>
      <FlowingCircles />
      <Outlet />
    </>
  );
};

export default AuthLayout;
